import {
    animateChild, group, animate, style, query, sequence
  } from '@angular/animations';

export const fadeOutAndIn = [
    style({
        position: 'relative'
    }),
    query(':enter, :leave', [
        style({
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%'
        })
    ], {
        optional: true
    }),

    query(':leave', [
        style({})
    ], {
        optional: true
    }),

    query(':enter', [
        style({
            opacity: 0,
        })
    ], {
        optional: true
    }),

    query(':leave', animateChild(), {
        optional: true
    }),

    sequence([
        query(':leave', [
        animate('650ms cubic-bezier(.6,.08,.06,.6)', style({
            opacity: 0
        }))
        ], {
            optional: true
        }),

        query(':enter', [
        animate('800ms cubic-bezier(.85,.09,.08,.8)', style({
            opacity: 1,
            backgroundColor: 'black'
        }))
        ],{
            optional: true
        })
    ])
];
